import { ActionList, Button, Popover, Modal, TextContainer } from "@shopify/polaris";

import React, { useState, useCallback } from "react";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { useAppContext } from "../../../context";
import { getParamByRole, handleError, reducerFn } from "../../../helper";
import { useHistory } from "react-router-dom";
import ProductTemplateAccessLevel from "./product-template-access-level";
import { REVOKE_ACCESS_TIKTOK_PRODUCT_TEMPLATE } from "../../../graphql/mutations/tiktok";
import { useProductTemplateAccessLevel } from "./product-template-access-level-ctx";
const _ = require('lodash');

const DELETE_SELECTED_TEMPLATE = gql`
	mutation deleteTiktokProductTemplate($id: ID!) {
		deleteTiktokProductTemplate(id: $id)
	}
`;

export default function ProductTemplateActions({item, onActionCompleted, disableAction}) {
	const history = useHistory();
	const [open, setOpen] = useState(false);
	const [actionInModal, setActionInModal] = useState({});
	const [modalActionLoading, setModalActionLoading] = useState(false);
	const [activeRow, setActiveRow] = useState(null);
	const [state, setState] = React.useReducer(reducerFn, {
		open: false,
	})

	const { currentUser } = useAppContext();
	const { refetch } = useProductTemplateAccessLevel() || {};

	const isAuthor = _.get(item, "createdBy.id") === _.get(currentUser, "id") && !!_.get(currentUser, "id");
	const param = getParamByRole(currentUser);

	const handleStateChange = React.useCallback((value) => () => {
		setState({ open: value })
	}, [])

	const handleAction = (action, item) => {
		switch(action) {
			case 'edit':
				let itemDetailUrl = `/${param}/tiktok-hub/product-templates/${item?.id}`;
				history.push(itemDetailUrl);
				break
			case 'clone':
				let linkClone = `/${param}/tiktok-hub/product-templates/${item?.id}/clone`;
				history.push(linkClone);
				break
			case 'revoke':
				setOpen(true);
				setActionInModal({
					action,
					item
				});
				break;
			case 'delete':
				setOpen(true);
				setActionInModal({
					action,
					item
				});
				break;
		}
		setActiveRow(null); // Close the popover
	};

	const renderActions = useCallback((item) => {
		let actions = [{
			content: 'Edit template',
			onAction: () => handleAction('edit', item),
		}];
		actions.push({
			content: 'Clone template',
			onAction: () => handleAction('clone', item),
		});

		if (isAuthor) {
			actions.push({
				onAction: handleStateChange(true),
				content: 'Grant access template',
			})

			actions.push({
				content: 'Revoke access template',
				onAction: () => handleAction('revoke', item),
			})
		}

		if (isAuthor) {
			actions.push({
			content: 'Delete template',
			onAction: () => handleAction('delete', item),
		})
	};

		return (
			<Popover
				active={activeRow === item.id}
				activator={
					<Button disabled={disableAction} disclosure onClick={() => {
						setActiveRow(prevActiveRow => {
							let newActiveRow = (prevActiveRow === item.id ? null : item.id);
							return newActiveRow;
						});
					}}>Actions</Button>
				}
				onClose={() => setActiveRow(null)}
			>
				<ActionList items={actions} />
			</Popover>
		)
	}, [activeRow]);

	const handleModalChange = useCallback(() => setOpen((open) => !open), []);

	const [deleteTiktokProductTemplate, {}] = useMutation(DELETE_SELECTED_TEMPLATE);
	const [revokeAccessTemplate] = useMutation(REVOKE_ACCESS_TIKTOK_PRODUCT_TEMPLATE);
	let validActions = {
		delete: deleteTiktokProductTemplate,
		revoke: revokeAccessTemplate,
	}

	const modalActionLabels = {
		delete: {
			heading: 'Delete this template: #' + (item?.id || ''),
			label: 'Delete this template',
			confirmText: 'Are you sure to delete the selected template?',
		},
		revoke: {
			heading: 'Revoke access this template: #' + (item?.id || ''),
			label: 'Revoke access this template',
			confirmText: 'Are you sure to revoke access the selected template?',
		}
	}

	return (
		<>
			{renderActions(item)}
			<ProductTemplateAccessLevel open={state.open} onClose={handleStateChange(false)} template={item} onCompleted={onActionCompleted}/>

			<Modal
				title={modalActionLabels?.[actionInModal?.action]?.heading}
				open={open}
				onClose={handleModalChange}
				primaryAction={{
					content: modalActionLabels?.[actionInModal?.action]?.label,
					loading: modalActionLoading,
					onAction: () => {
						setModalActionLoading(true);

						let selectedItem = actionInModal?.item
						if (selectedItem) {
							const isRevoke = actionInModal?.action === "revoke"
							switch (actionInModal?.action) {
								case 'delete':
								case 'revoke':
									validActions[actionInModal.action]({
										variables:  isRevoke ? {ids: [selectedItem.id]} :{ id: selectedItem.id },
									})
									.then((res) => {
										setModalActionLoading(false);
										if (res && onActionCompleted) {
											onActionCompleted({
												type: 'success',
												message: _.startCase(actionInModal?.action) + ' processed successfully',
											});

											if (isRevoke && refetch) {
												refetch()
											}
										}
									}).catch((err) => {
										setModalActionLoading(false);
										if (onActionCompleted) {
											onActionCompleted({
												type: 'fail',
												message: err ? handleError(err.toString()) : _.startCase(actionInModal?.action) + ' failed to process',
											});
										}
									}).finally(() => {
										setOpen(false);
									});
									break;
							}
						}
					}
				}}
				secondaryActions={[
					{
						content: "Cancel",
						onAction: handleModalChange,
					},
				]}
			>
				<Modal.Section>
					<TextContainer>
						<div dangerouslySetInnerHTML={{ __html: modalActionLabels?.[actionInModal.action]?.confirmText }} />
					</TextContainer>
				</Modal.Section>
			</Modal>
		</>
	);
}